import { StoreFontEnum as o } from "../enums/store-font-enum.mjs";
const n = {
  [o.Inter]: [400, 500, 600, 700],
  [o.Roboto]: [400, 500, 700],
  [o.Lato]: [400, 700],
  [o.Montserrat]: [400, 500, 600, 700],
  [o.OpenSans]: [400, 600, 700],
  [o.Poppins]: [400, 500, 600, 700],
  [o.Arizonia]: [400],
  [o.Kanit]: [400, 500, 600, 700],
  [o.Merriweather]: [400, 700],
  [o.NotoSans]: [400, 700],
  [o.Nunito]: [400, 600, 700],
  [o.PlayfairDisplay]: [400, 500, 600, 700],
  [o.SourceSansPro]: [400, 600, 700],
  [o.Ubuntu]: [400, 500, 700],
  [o.Lora]: [400, 500, 600, 700]
};
export {
  n as fontWeights
};
